import { maLookback } from '../../math/ma'
import { COLOR, float, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'BOLL',
  version: 2,
  label: 'Bollinger Bands',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 40,
  // TA-Lib's own default length is 5; 20/2/2 is what every charting platform ships.
  inputs: [period('timeperiod', 20), float('nbdevup', 2, 'StdDev up', 0, 100, 0.1), float('nbdevdn', 2, 'StdDev down', 0, 100, 0.1), matype()],
  outputs: [line('upper', 'Upper', COLOR.blue), line('middle', 'Basis', COLOR.orange), line('lower', 'Lower', COLOR.blue)],
  talib: {
    functions: ['BBANDS'],
    expr: 'BBANDS(close, timeperiod={timeperiod}, nbdevup={nbdevup}, nbdevdn={nbdevdn}, matype={matype})',
    outputs: { upper: 'upperband', middle: 'middleband', lower: 'lowerband' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype }) => maLookback(timeperiod, matype),
}
export default def
